import {AfterViewInit, Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {PasoWizard} from "../../../../interface/wizard-informacion.types";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {WIZARD_DATA} from "../../../../tokens/tokens";
import {ButtonControlService} from "../../../../services/button-control.service";
import {EvkHttpService} from "@evomatik/evk-common";
import {DataWizardService} from "../../../../services/data-wizard.service";
import {EvkSeccionModel} from "../../../../../expediente/models/evk-seccion.model";
import {DatosSeccionWizardEventsService} from "../../../../services/datos-seccion-wizard-events.service";
import {WizardEventsService} from "../../../../services/wizard-events.service";

@Component({
    selector: 'validacion-codigo',
    templateUrl: './validacion-codigo.component.html',
    styleUrls: ['./validacion-codigo.component.css']
})
export class ValidacionCodigoComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input()
    config: PasoWizard;

    paso: PasoWizard;

    folioExpediente: string;

    showSpinner: boolean;

    readonly: boolean;

    showValidIcon: boolean;

    showInvalidIcon: boolean;

    doneForm: Subject<boolean> = new Subject<boolean>();

    private _unsubscribeAll: Subject<any>;

    validacionCodigoForm: FormGroup = new FormGroup({
        codigoValidacion: new FormControl('', Validators.required)
    });

    constructor(@Inject(WIZARD_DATA) public data: any,
                public http: EvkHttpService,
                public dataWizardService: DataWizardService,
                private buttonControlService: ButtonControlService,
                public datosSeccionWizard: DatosSeccionWizardEventsService,
                private wizardEventsService: WizardEventsService) {
        this._unsubscribeAll = new Subject();
        this.showSpinner = false;
        this.readonly = false;
        this.showValidIcon = false;
        this.showInvalidIcon = false;
        this.folioExpediente = '';
        this.paso = data.paso;
    }

    ngAfterViewInit() {
        this.validarInformacion();
        this.obSerbarCambiosDataExpediente();
    }

    ngOnInit(): void {
        this.validacionCodigoForm.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(value => {
            if (this.validacionCodigoForm.valid && (this.paso.inData['codigoValidacion'] === undefined )) {
                this.readonly = true;
                this.showSpinner = true;
                this.showValidIcon = false;
                this.showInvalidIcon = false;
                this.http.post('/seaged-gobierno-codigo-validacion/v1/seaged/codigo/verificar', {
                    folio: this.folioExpediente,
                    codigo: this.validacionCodigoForm.controls.codigoValidacion.value
                }).pipe(takeUntil(this._unsubscribeAll)).subscribe((data: any) => {
                    if (data['verificado'] === true) {
                        this.showSpinner = false;
                        this.showValidIcon = true;
                        this.buttonControlService.cambiarBotonSiguiente(data['verificado']);
                    }
                }, (error: any) => {
                    this.readonly = false;
                    this.showSpinner = false;
                    this.showInvalidIcon = true;
                });
                this.onSelectionChanged(value);
            }
        });
    }

    onSelectionChanged(data: any, save?: boolean) {
        const response: EvkSeccionModel = {
            origen: this.config.nombre,
            propiedades: data
        }
        if (save) {
            this.datosSeccionWizard.onDoneSave.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
                this.wizardEventsService.save();
            })
        }
        this.datosSeccionWizard.doneSave(response);
    }

    public obSerbarCambiosDataExpediente() {
        this.dataWizardService.dataWizard.subscribe(data => {
            this.folioExpediente = data.folioNegocio;
        });
    }

    validarInformacion() {
        if (this.paso.inData !== null && this.paso.inData['codigoValidacion'] !== undefined) {
            this.validacionCodigoForm.patchValue(this.paso.inData);
            this.readonly = true;
            this.showValidIcon = true;
            this.buttonControlService.cambiarBotonSiguiente(true);
        } else {
            this.buttonControlService.cambiarBotonSiguiente(false);
        }
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this._unsubscribeAll.unsubscribe();
        this.dataWizardService.stopSubscriptions();
    }

}
